<template>
  <div class="grid">
    <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3">
              <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                {{ $t("aboutus") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3">
              <Button iconPos="right" :label="$t('add')" v-tooltip.bottom="$t('add')" icon="pi pi-plus" @click="openNew"
                size="small" style="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText format="text" v-model="search_filter" @input="search(1)">
                  </InputText>
                  <label>{{ $t("search") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown id="status" v-model="status_dropdownItem" :options="status_dropdownItems" optionLabel="name"
                    filter @change="search(1)">
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button icon="pi pi-refresh" v-tooltip.bottom="$t('refresh')" @click="search(2)" class="p-button-rounded p-button-danger"
                  style="" />
              </div>
            </div>
          </div>
        </div>
        <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
          :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit" :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll" style="font-size: 12px" :rowHover="true" showGridlines>
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column :header="$t('status')" style="min-width: 8rem; text-align: center" :field="columns[5]">
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'">
                <badge class="p-button-success" value="Active" severity="success"></badge>
              </span>
              <span v-else-if="data.status == 'In Active' || data.status == 'Inactive'">
                <badge class="p-button-warning" value="In Active" severity="warning"></badge>
              </span>
              <span v-else-if="data.status == 'Deleted' || data.status == 'Deleted'">
                <badge class="p-button-danger" value="Deleted" severity="danger"></badge>
              </span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column :header="$t('title')" style="min-width: 5rem" v-if="language=='en'">
            <template #body="{ data }">
              {{ data.title }}
            </template>
          </Column>
          <Column :header="$t('title')" style="min-width: 5rem" v-if="language=='mr'">
            <template #body="{ data }">
              {{ data.title_mr }}
            </template>
          </Column>
          <Column :header="$t('title')" style="min-width: 5rem" v-if="language=='hi'">
            <template #body="{ data }">
              {{ data.title_hi }}
            </template>
          </Column>
          <Column :header="$t('description')" style="min-width: 5rem" v-if="language=='en'">
            <template #body="{ data }">
              {{ data.description }}
            </template>
          </Column>
          <Column :header="$t('description')" style="min-width: 5rem" v-if="language=='mr'">
            <template #body="{ data }">
              {{ data.description_mr }}
            </template>
          </Column>
          <Column :header="$t('description')" style="min-width: 5rem" v-if="language=='hi'">
            <template #body="{ data }">
              {{ data.description_hi }}
            </template>
          </Column>
          <Column :header="$t('video')" style="min-width: 5rem">
            <template #body="slotProps">
              <Button icon="pi pi-video" title="$t('view_video')" v-tooltip.bottom="$t('video')"
                class="p-button-rounded p-button-warning mr-2" @click="viewvideo(slotProps.data.video)" style="" />
            </template>
          </Column>
          <Column :header="$t('images')" style="min-width: 5rem">
            <template #body="slotProps">
              <Button icon="pi pi-images" title="$t('view_image')" v-tooltip.bottom="$t('image')"
                class="p-button-rounded p-button-warning mr-2" @click="viewimages(slotProps.data.image)" style="" />
            </template>
          </Column>
          <Column :header="$t('attachments')" style="min-width: 5rem">
            <template #body="slotProps">
              <Button icon="pi pi-paperclip" title="$t('view_atachment')" v-tooltip.bottom="$t('attachment')"
                class="p-button-rounded p-button-warning mr-2" @click="viewattach(slotProps.data.attachment)"
                style="" />
            </template>
          </Column>
          <Column :header="$t('action')" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button v-if="slotProps.data.status != 'Deleted'" icon="pi pi-pencil" 
                v-tooltip.bottom="$t('edit')" class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)" style="" />
              <Button v-if="slotProps.data.status != 'Deleted'" icon="pi pi-trash" v-tooltip.bottom="$t('delete')"
                class="p-button-rounded p-button-danger mt-2" @click="confirmDeleteProduct(slotProps.data)" style="" />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <Dialog v-model:visible="viewDialog" :breakpoints="{ '960px': '75vw' }" :style="{ width: '55vw' }"
      :header="$t('view_images')" :modal="true" position="top">
      <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div v-for="(image, index) in uploadedImages" :key="index" class="col-md-2 mr-2">
            <div class="p-2 border-1 surface-border border-round text-center">
              <img :src="image" alt="Preview" class="mb-2 border-round" style="height: 100px; object-fit: cover" />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog v-model:visible="productDialog" :breakpoints="{ '960px': '75vw' }" :style="{ width: '75vw' }"
      :header="$t('aboutus')" :modal="true" position="top">
      <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown id="status" v-model="addeditstatus_dropdownItem" :options="status_dropdownItems"
                optionLabel="name" filter :disabled="!product._id">
              </Dropdown>
              <label for="status">{{ $t("status") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-9" style="margin-top: 2%"></div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText id="title" type="text" v-model="product.title" />
              <label for="name">{{ $t("title") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText id="title_mr" type="text" v-model="product.title_mr" />
              <label for="name">{{ $t("title_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText id="title_hi" type="text" v-model="product.title_hi" />
              <label for="name">{{ $t("title_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea id="description" type="text" rows="4" v-model="product.description" />
              <label for="name">{{ $t("description") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea id="description_mr" type="text" rows="4" v-model="product.description_mr" />
              <label for="name">{{ $t("description_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea id="description_hi" type="text" rows="4" v-model="product.description_hi" />
              <label for="name">{{ $t("description_hi") }}</label>
            </span>
          </div>
        </div>
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-2" style="margin-top: 2%">
            <FileUpload ref="fileUploader" class="p-button-primary" mode="basic" name="model[]" :auto="true"
              :custom-upload="true" :choose-label="$t('upload_video')" accept="video/*"
              @uploader="handleVideoUpload($event)" />
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 2%" v-if="video_url != ''">
            <Button icon="pi pi-video" :title="$t('view_details')" v-tooltip.bottom="$t('view')"
              class="p-button-success mr-2" @click="viewvideo()" />
            <Button icon="pi pi-trash" class="p-button-danger " @click="removeVideo(index)" />
          </div>
           <div class="field col-12 md:col-2" style="margin-top: 2%">
            <FileUpload ref="fileUploader" class="p-button-primary" mode="basic" name="model[]" :auto="true"
              :custom-upload="true" :choose-label="$t('attachment')" accept="application/pdf"
              @uploader="handleFileUpload($event)" />
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 2%" v-if="url != ''">
            <Button icon="pi pi-paperclip" :title="$t('view_details')" v-tooltip.bottom="$t('view')"
              class="p-button-success mr-2" @click="viewattach()" />
            <Button icon="pi pi-trash" class="p-button-danger " @click="removeAttachment(index)" />
          </div>
        </div>
       
        
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-12" style="margin-top: 2%">
            <FileUpload ref="fileUploader" class="p-button-primary" mode="basic" name="model[]" :auto="true"
              :custom-upload="true" :choose-label="$t('uploadmultipleimages')" accept="image/*"
              @uploader="uploadHandler($event)" />
            <div class="grid mt-3">
              <div v-for="(image, index) in uploadedImages" :key="index" class="col-3">
                <div class="p-2 border-1 surface-border border-round text-center">
                  <img :src="image" alt="Preview" class="mb-2 border-round" style="height: 100px; object-fit: cover" />
                  <Button label="Remove" icon="pi pi-trash" class="p-button-danger p-button-sm"
                    @click="removeImage(index)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button :label="$t('save')" @click="save_event" icon="pi pi-check" class="p-button-success" />
      </template>
    </Dialog>
    <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" :header="$t('Confirm')" :modal="true">
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product">{{ $t("delete_msg") }}<b>{{ product.title }}</b>?</span>
      </div>
      <template #footer>
        <Button :label="$t('no')" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
        <Button :label="$t('yes')" icon="pi pi-check" class="p-button-text" @click="deleteevent" />
      </template>
    </Dialog>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      language:'en',
      uploadedImages: [],
      video_url: '',
      url: '',
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "In Active", value: "In Active" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      viewDialog: false,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    currentLocale() {
        this.language = this.$i18n.locale;
    },
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    viewimages(image) {
      this.uploadedImages = [];
      if (image && Object.keys(image).length > 0) {
        const images = Object.values(image);
        for (let index = 0; index < images.length; index++) {
          this.uploadedImages.push(images[index]);
        }
      }
      this.viewDialog = true;
    },
    removeAttachment() {
      this.url = '';
    },
    removeVideo() {
      this.video_url = '';
    },
    async uploadHandler(event) {
      var fileUp = event.files[0];
      var file = fileUp;
      if (!file.type.startsWith("image/")) {
        this.$refs.fileUploader.clear();
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("Only images are allowed."),
          life: 3000,
        });
        return false;
      }
      this.file = file;
      var prfeix = await this.date_time_prefix();
      var filename = prfeix + "_" + file.name;
      this.file_data = {
        filePath: filename,
        contentType: file.type,
      };
      var promise = apis.upload_to_AWS(this.file_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            var temp =
              "https://eticket-docs.s3.ap-south-1.amazonaws.com/" + filename;
            this.uploadedImages.push(temp);
          });
      });
    },
    removeImage(index) {
      this.uploadedImages.splice(index, 1);
    },
    async date_time_prefix() {
      // Get the current date and time
      const currentDateTime = new Date();
      // Format the date as YYYY_MM_DD
      const formattedDate = currentDateTime
        .toISOString()
        .split("T")[0]
        .replace(/-/g, "_");
      // Format the time as HH_mm_ss
      const formattedTime = currentDateTime
        .toTimeString()
        .split(" ")[0]
        .replace(/:/g, "_");
      // Construct the final string
      const resultString = `${formattedDate}_${formattedTime}`;
      return resultString;
    },
    //attachmet
    viewattach(attachment) {
      if (attachment) {
        window.open(attachment)
      } else {
        window.open(this.url)
      }
    },
    async handleFileUpload(event) {
      var fileUp = event.files[0];
      var file = fileUp;
      if (file.type !== "application/pdf") {
        this.$refs.fileUploader.clear();
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("Only PDF files are allowed."),
          life: 3000,
        });
        return false;
      }
      this.file = file;
      var prfeix = await this.date_time_prefix();
      var filename = prfeix + "_" + file.name;
      this.file_data = {
        filePath: filename,
        contentType: file.type,
      };
      var promise = apis.upload_to_AWS(this.file_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.url =
              "https://eticket-docs.s3.ap-south-1.amazonaws.com/" + filename;
          });
      });
    },
    //for video
    viewvideo(video) {
      if (video) {
        window.open(video)
      } else {
        window.open(this.video_url)
      }
    },
    async handleVideoUpload(event) {
      var fileUp = event.files[0];
      var file = fileUp;
      if (file.type !== "video/mp4") {
        this.$refs.fileUploader.clear();
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("Only mp4 Video files are allowed."),
          life: 3000,
        });
        return false;
      }
      this.file = file;
      var prfeix = await this.date_time_prefix();
      var filename = prfeix + "_" + file.name;
      this.file_data = {
        filePath: filename,
        contentType: file.type,
      };
      var promise = apis.upload_to_AWS(this.file_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.video_url =
              "https://eticket-docs.s3.ap-south-1.amazonaws.com/" + filename;
          });
      });
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    async save_event() {
      if (!this.product.title) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_title"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.title_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_title_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.title_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_title_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.description) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_description"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.description_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_description_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.description_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_description_hi"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      var imageObject = {};
      if (this.uploadedImages != []) {
        this.uploadedImages.forEach((url, index) => {
          imageObject[index] = url;
        });
      }
      if (this.product._id) {
        details = {
          "_id": this.product._id,
          "title": this.product.title,
          "title_mr": this.product.title_mr,
          "title_hi": this.product.title_hi,
          "description": this.product.description,
          "description_mr": this.product.description_mr,
          "description_hi": this.product.description_hi,
          "attachment": this.url,
          "image": imageObject,
          "video": this.video_url,
          "status": this.addeditstatus_dropdownItem?.value,
          "updated_by": localStorage.getItem("id"),
          "lang": this.$i18n.locale,
        };
        var promise = apis.updateAboutus(details);
      } else {
        details = {
          "title": this.product.title,
          "title_mr": this.product.title_mr,
          "title_hi": this.product.title_hi,
          "description": this.product.description,
          "description_mr": this.product.description_mr,
          "description_hi": this.product.description_hi,
          "attachment": this.url,
          "image": imageObject,
          "video": this.video_url,
          "status": this.addeditstatus_dropdownItem?.value,
          "created_by": localStorage.getItem("id"),
          "client_id": localStorage.getItem("client_id"),
          "lang": this.$i18n.locale,
        };
        var promise = apis.createAboutus(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: true,
        "lang": this.$i18n.locale,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.ListAboutUs(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        "lang": this.$i18n.locale,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.ListAboutUs(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.addeditstatus_dropdownItem = { name: "Active", value: "Active" };
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.video_url = "";
      this.url = "";
      this.uploadedImages = [];
      this.product = { ...product };
      this.addeditstatus_dropdownItem = null;
      if (this.product.status) {
        this.addeditstatus_dropdownItem = {
          name: this.product.status,
          value: this.product.status,
        };
      }
      if (this.product.video) {
        this.video_url = this.product.video;
      }
      if (this.product.attachment) {
        this.url = this.product.attachment;
      }
      if (this.product.image && Object.keys(this.product.image).length > 0) {
        const images = Object.values(this.product.image);
        for (let index = 0; index < images.length; index++) {
          this.uploadedImages.push(images[index]);
        }
      }
      this.productDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          "_id": this.product._id,
          "updated_by": localStorage.getItem("id"),
          "lang": this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.deleteAboutus(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Asset Type");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>